import gsap from 'gsap';

import PageMask from './_pagemask';
import Mainvisual from './_mv';


export default class Opening{

    setup(){
        this.pageMask = new PageMask();
        this.mv = new Mainvisual();
        
        if(!VILE.session._isOpeningViewed){
            this._anime();
            VILE.session._isOpeningViewed = 1;
        }
        else{
            document.body.classList.add('-opening');
            
            setTimeout(()=>{
                this._showMv();
            }, 500);
            setTimeout(() => {
                this.pageMask._endOpening();
            }, 2500);
        }
    }

    _anime(){
        this.tl = gsap.timeline();
		this.tl
			.add(this._showPage.bind(this))
            .add(this._showMv.bind(this), "+=1.5");
    }

    _showPage(){
        this.pageMask.render();
        document.body.classList.add('-opening');
    }

    _showMv(){
        this.mv.render();

        if(location.hash){
            window.VILE.anchor.move();
        }
    }
}
